import { registerApi as api } from '../../api';

/** Check if (state, leave_code) already exists. For create: omit excludeId. For edit: pass current record id. */
export const checkLeaveMasterDuplicate = async (state, leaveCode, excludeId = null) => {
  try {
    const token = sessionStorage.getItem('token');
    const params = new URLSearchParams({ state: state || '', leave_code: leaveCode || '' });
    if (excludeId != null && excludeId !== '') params.set('exclude_id', String(excludeId));
    const response = await api.get(`/leave_master_check_duplicate?${params.toString()}`, {
      headers: { 'Authorization': `Bearer ${token}` },
    });
    return { duplicate: response.data?.duplicate === true };
  } catch (error) {
    return { duplicate: false };
  }
};

export const createLeaveMaster = async (LeaveData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/leave_master_create', LeaveData, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    return {
      data: response.data,
      status: response.status,
    }

  } catch (error) {
    const data = error.response?.data;
    const msg =
      (typeof data?.error === 'string' && data.error) ||
      (typeof data?.message === 'string' && data.message) ||
      (typeof error.message === 'string' && error.message) ||
      (error.response?.statusText) ||
      'Unknown error';
    throw msg;
  }
}

export const fetchLeaveData = async () => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.get('/leave_master_get', {
      headers: {
        'Authorization': `Bearer ${token}`,
      }

    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const updateLeave = async (id, LeaveData) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.put(`/leave_master_update/${id}`, LeaveData, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }

    })
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

export const deleteLeave = async (id) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.delete(`/leave_master_delete/${id}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
}

// export const leaveMasterDataUpload = async (LeaveDataInput) => {
//     const token = sessionStorage.getItem('token');
//     // const selectedClientID = sessionStorage.getItem('selectedClient')
//     const response = await api.post('/upload_leave_master', LeaveDataInput, {
//       headers: {
//         'Authorization': `Bearer ${token}`,
//         'Content-Type': 'multipart/form-data'
//       },
//             // IMPORTANT: Don't reject on non-200 status for partial uploads
//             validateStatus: (status) => status === 200 || status === 400
//         }
//     );
    
//     return response.data;
    
// };

// Make sure your API function is set up correctly
export const leaveMasterDataUpload = async (fileData) => {
    const formData = new FormData();
    formData.append('file', fileData);
    
    const token = sessionStorage.getItem('token');
    const selectedClientID = sessionStorage.getItem('selectedClient')
    const response = await api.post('/upload_leave_master', formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
      },
            // IMPORTANT: Don't reject on non-200 status for partial uploads
            validateStatus: (status) => status === 200 || status === 400
        }
    );
    
    return response.data;
};






export const multiDeleteLeaveMaster = async (ids) => {
  try {
    const token = sessionStorage.getItem('token');
    const response = await api.post('/delete_multipleLeave', ids, {
      headers: {
        'Authorization': `Bearer ${token}`,
      }
    });
    console.log(response.data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data.error : error.message;
  }
};
